import { render, staticRenderFns } from "./midBtm.vue?vue&type=template&id=1ef81874&scoped=true&"
import script from "./midBtm.vue?vue&type=script&lang=js&"
export * from "./midBtm.vue?vue&type=script&lang=js&"
import style0 from "./midBtm.vue?vue&type=style&index=0&id=1ef81874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef81874",
  null
  
)

export default component.exports